// src/components/Header.js
import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import { useUser } from '../contexts/UserContext';
import { 
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Button,
  Switch,
  Box,
  useMediaQuery
} from '@mui/material';
import { Brightness4, Brightness7 } from '@mui/icons-material';

import logoImgOnlyS from '../assest/logo/logo-icon.png'
const Header = () => {
  const { theme, toggleTheme } = useTheme();
  const { user, logout } = useUser();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <AppBar position="static" sx={{position:'sticky'}} elevation={0}>
      <Toolbar>
        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
             <img src={logoImgOnlyS} alt="" width={60} />
        </Typography>

        {/* Theme Toggle */}
        <Box sx={{ display: 'flex', alignItems: 'center', mr: 2 }}>
          {isMobile ? (
            <IconButton onClick={toggleTheme} color="inherit">
              {theme.palette.mode === 'dark' ? <Brightness7 /> : <Brightness4 />}
            </IconButton>
          ) : (
            <>
              <Brightness4  />
              <Switch
                checked={theme.palette.mode === 'dark'}
                onChange={toggleTheme}
                color="default"
              />
              <Brightness7 />
            </>
          )}
        </Box>

        {/* User/Auth Controls */}
        {/* {user ? (
          <Button color="inherit" onClick={logout}>
            Logout
          </Button>
        ) : (
          <Button color="inherit">Login</Button>
        )} */}
      </Toolbar>
    </AppBar>
  );
};

export default Header;